import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSelector } from "react-redux";
import { auth } from "../Services/FirebaseService";
import { getActiveBrandConfig } from "../config/environment.config";
import BackdropLoad from "../Components/BackdropLoad";

interface RoleViewProps {
    /** Vue prof / coach / prestataire. */
    prof: React.ReactElement;
    /**
     * Vue client sur la même URL. Absente, la route est réservée au prof et
     * un client est ramené à l'accueil du tableau de bord.
     */
    client?: React.ReactElement;
}

/**
 * Tableau de bord commun : une seule URL par rubrique, le contenu affiché
 * dépend du rôle connecté (prof ou client). Un visiteur non connecté est
 * renvoyé vers la page de connexion.
 */
const RoleView = ({ prof, client }: RoleViewProps) => {
    const currentUser = useSelector((state: any) => state.user.currentUser);
    const [user, loadingAuth] = useAuthState(auth);
    const navigate = useNavigate();

    useEffect(() => {
        // on attend la restauration de la session Firebase avant de décider
        if (loadingAuth) return;
        if (!user || !currentUser?.isAuthenticated) {
            navigate("/");
        }
    }, [loadingAuth, user, currentUser, navigate]);

    if (loadingAuth) {
        return <BackdropLoad />;
    }
    if (currentUser?.isClient) {
        return client ?? <Navigate to={`/${getActiveBrandConfig()}/tableau-de-bord`} replace />;
    }
    return prof;
};

export default RoleView;
